/* eslint-disable */
// Do not edit this file, it is auto-generated at build time!
// See scripts/generate-component-factory.js to modify the generation of this file.

import './assets/app.css';
import './assets/core/css/fonts/index.css';
import './assets/core/css/index.css';
import './assets/core/css/tailwind.css';
import './assets/rotaryintl_default_overrides.css';

import GlobalHeader from './components/GlobalHeader';
import GlobalFooter from './components/GlobalFooter';
import FullWidthSublayout from './sublayouts/FullWidthSublayout';
import NavSublayout from './sublayouts/NavSublayout';
import FullWidthSublayoutNoContainer from './sublayouts/FullWidthSublayoutNoContainer';
import CalloutWithScrollData from './components/CalloutWithScrollData';
import HomeHeroComponent from './components/HomeHero';
import CardGridComponent from './components/CardGrid';
import CardComponent from './components/Card';
import ImageVideoCallout from './components/ImageVideoCallout';
import PageTitleComponent from './components/PageTitle';
import CalloutCardListComponent from './components/CalloutCardList';
import CalloutCardComponent from './components/CalloutCard';
import BodyCopyComponent from './components/BodyCopy';
import TopicPanelComponent from './components/TopicPanel';
import ImageWithTextCard from './components/ImageWithTextCard';
import ColorWithTextCard from './components/ColorWithTextCard';
import ColorBlockCallout from './components/ColorBlockCallout';
import BreadCrumbComponent from './components/BreadCrumb';
import MegaMenu from './components/MegaMenu';
import TextListContainer from './components/TextListContainer';
import TopicCardComponent from './components/TopicCard';
import TopicLinksCard from './components/TopicLinksCard';
import ColorBlockCalloutListComponent from './components/ColorBlockCalloutWrapper';
import SideNavComponent from './components/SideNavigation';
import LargerImageTextListComponent from './components/LargerImageTextList';
import LargerImageTextBlockComponent from './components/LargerImageText';
import ChineseLanguageBannerComponent from './components/ChineseLanguageBanner';
import MetaTags from './components/MetaTags';
import CookieBannerComponent from './components/CookieBanner';
import ChiliPublishTemplateComponent from './components/ChiliIframeTemplate';
import CenteredBodyComponent from './components/CenteredBodyControl';
import BannerComponent from './components/Banner';
import NoWidthContainerSublayout from './sublayouts/NoWidthContainerSubLayout';
import AssetExplorerComponent from './components/AssetExplorerComponent';
import AssetExplorerStandaloneComponent from './components/AssetExplorerStandaloneComponent';
import HTML5Video from './components/HTML5Video';
import Quote from './components/Quote';
import Alert from './components/Alert';
import Hero from './components/Hero';
import Timeline from './components/Timeline';
import RelatedContent from './components/RelatedContent';
import CountdownTimer from './components/CountdownTimer';
import OneColumnText from './components/OneColumnText';
import IconGrid from './components/IconGrid';
import IconGridCard from './components/IconGridCard';
import CTACallout from './components/CTACallout';
import Divider from './components/Divider';
import LogoGrid from './components/LogoGrid';
import TwoUp from './components/TwoUp';
import Button from './components/Button';
import LatestNewsGrid from './components/LatestNewsGrid';
import LatestNewsGridCard from './components/LatestNewsGridCard';
import LinkCard from './components/LinkCard';
import TwoUpText from './components/TwoUpText';
import Speaker from './components/Speaker';
import CTAIconLink from './components/CTAIconLink';
import FullWidthCTA from './components/FullWidthCTA';
import LoginModal from './components/LoginModal';
import GlobalBannerNotifications from './components/GlobalBannerNotifications';
import SpeakerGrid from './components/SpeakerGrid';
import InfogramEmbed from './components/InfogramEmbed';
import WakeletEmbed from './components/WakeletEmbed';
import Accordion from './components/Accordion';
import SectionHeader from './components/SectionHeader';
import CoveoSearchSublayout from './sublayouts/CoveoSearchSublayout';
import CoveoSearch from './components/CoveoSearch';
import Video from './components/Video';
import YoutubeVideo from './components/YoutubeVideo';

const components = new Map();
components.set('GlobalHeader', GlobalHeader);
components.set('GlobalFooter', GlobalFooter);
components.set('FullWidthSublayout', FullWidthSublayout);
components.set('NavSublayout', NavSublayout);
components.set('FullWidthSublayoutNoContainer', FullWidthSublayoutNoContainer);
components.set('ImageandVideoCallout', ImageVideoCallout);
components.set('CalloutWithScrollButton', CalloutWithScrollData);
components.set('HomePageHero', HomeHeroComponent);
components.set('BodyCopy', BodyCopyComponent);
components.set('CardGrid', CardGridComponent);
components.set('CardGridCard', CardComponent);
components.set('PageTitle', PageTitleComponent);
components.set('CalloutCardList', CalloutCardListComponent);
components.set('CalloutCard', CalloutCardComponent);
components.set('TopicPanel', TopicPanelComponent);
components.set('ImageWithTextCard', ImageWithTextCard);
components.set('ColorWithTextCard', ColorWithTextCard);
components.set('ColorBlockCallout', ColorBlockCallout);
components.set('ColorBlockCalloutList', ColorBlockCalloutListComponent);
components.set('Breadcrumb', BreadCrumbComponent);
components.set('MegaMenu', MegaMenu);
components.set('TextListContainer', TextListContainer);
components.set('TopicCard', TopicCardComponent);
components.set('TopicLinksCard', TopicLinksCard);
components.set('SideNavigation', SideNavComponent);
components.set('LargerImageTextList', LargerImageTextListComponent);
components.set('LargerImageText', LargerImageTextBlockComponent);
components.set('ChineseLanguageBanner', ChineseLanguageBannerComponent);
components.set('MetaTags', MetaTags);
components.set('CookieBanner', CookieBannerComponent);
components.set('ChiliPublishTemplate', ChiliPublishTemplateComponent);
components.set('centeredbodycontrol', CenteredBodyComponent);
components.set('Banner', BannerComponent);
components.set('NoWidthContainerSublayout', NoWidthContainerSublayout);
components.set('AssetExplorer', AssetExplorerComponent);
components.set('AssetExplorerStandalone', AssetExplorerStandaloneComponent);
components.set('HTML5Video', HTML5Video);
components.set('Quote', Quote);
components.set('Timeline', Timeline);
components.set('RelatedContent', RelatedContent);
components.set('Hero', Hero);
components.set('CountdownTimer', CountdownTimer);
components.set('OneColumnText', OneColumnText);
components.set('IconGrid', IconGrid);
components.set('IconGridCard', IconGridCard);
components.set('CTACallout', CTACallout);
components.set('Divider', Divider);
components.set('LogoGrid', LogoGrid);
components.set('TwoUp', TwoUp);
components.set('Button', Button);
components.set('LatestNewsGrid', LatestNewsGrid);
components.set('LatestNewsGridCard', LatestNewsGridCard);
components.set('LinkCard', LinkCard);
components.set('TwoUpText', TwoUpText);
components.set('Speaker', Speaker);
components.set('CTAIconLink', CTAIconLink);
components.set('FullWidthCTA', FullWidthCTA);
components.set('LoginModal', LoginModal);
components.set('Alert', Alert);
components.set('GlobalBannerNotifications', GlobalBannerNotifications);
components.set('SpeakerGrid', SpeakerGrid);
components.set('InfogramEmbed', InfogramEmbed);
components.set('WakeletEmbed', WakeletEmbed);
components.set('Accordion', Accordion);
components.set('SectionHeader', SectionHeader);
components.set('CoveoSearchSublayout', CoveoSearchSublayout);
components.set('CoveoSearch', CoveoSearch);
components.set('Video', Video);
components.set('YoutubeVideo', YoutubeVideo);

export default function componentFactory(componentName) {
  return components.get(componentName);
}
